module.exports = __webpack_public_path__ + "img/fun.5c266d28.svg";